import { Statistics } from "@mezo/api"
import { useQuery } from "@tanstack/react-query"

import {
  ONE_MINUTE_IN_SECONDS,
  ONE_SECOND_IN_MILLISECONDS,
  PORTAL_API_URL_V2,
  queryKeysFactory,
} from "#/shared/constants"
import { safeFetch } from "#/shared/utils"

const staleTime = ONE_MINUTE_IN_SECONDS * 60 * ONE_SECOND_IN_MILLISECONDS
const url = new URL("statistics", PORTAL_API_URL_V2)

const useFetchStatistics = () =>
  useQuery<Statistics>({
    queryKey: [...queryKeysFactory.mezoKeys.statistics()],
    queryFn: async () => {
      const statistics = await safeFetch<Statistics>(
        url,
        "Failed to fetch statistics",
      )

      return statistics
    },
    staleTime,
    refetchInterval: staleTime,
    refetchOnWindowFocus: false,
  })

export default useFetchStatistics
